import { render } from "./class-list.vue?vue&type=template&id=481398f0&scoped=true"
import script from "./class-list.vue?vue&type=script&lang=js"
export * from "./class-list.vue?vue&type=script&lang=js"

import "./class-list.vue?vue&type=style&index=0&id=481398f0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-481398f0"

export default script